import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { LeftHandPanelDefaultFilterService } from '../../services/left-hand-panel-default-filter.service';
import { FilterService } from '../../../../Common/Filter/services/abstract-filter.service';
import { AuditableFiltersModel } from '../../../../Common/Filter/models/auditable-filters.model';
import { AuditableModel } from '../../../../Common/Misc/models/auditable.model';
import { UserAppPreferenceCommonFilters } from '../../../../Core/Users/models/user-app-preferences-filters.model';

@Component({
    selector: 'agpr-user-preference-filter-wrapper',
    templateUrl: './user-preference-filter-wrapper.component.html',
    styleUrls: ['./user-preference-filter-wrapper.component.scss'],
    providers: [
        {
            provide: FilterService,
            useClass: LeftHandPanelDefaultFilterService
        }
    ],
    standalone: false
})
export class UserPreferenceFilterWrapperComponent implements OnInit {
    @Input() id: string;
    @Input() items: AuditableModel[];
    @Input() initialValues: UserAppPreferenceCommonFilters;
    @Input() defaultFilters: AuditableFiltersModel;

    @Output() filterChange = new EventEmitter<void>();

    constructor() { }

    ngOnInit(): void {
    }
}
